import React from 'react';
import { Grid, Typography } from '@mui/material';
import NewModal from '../NewModal';

const PhotoModal = ({ open, items, onClose, onUpdate }) => {
  const updateButtons = [
    { label: '취소', onClick: onClose },
    {
      label: '삭제',
      color: 'error',
      onClick: onUpdate,
    },
  ];

  return (
    <NewModal open={open} buttons={updateButtons} onClose={onClose}>
      <Grid container>
        <Grid item xs={12}>
          <Typography variant="h5">
            {`${items.length}개의 사진을 삭제하시겠습니까?`}
          </Typography>
        </Grid>
      </Grid>
    </NewModal>
  );
};

export default PhotoModal;
